<template>
  <v-app-bar
    dark
    app
    height="110"
    :style="computedBarStyle"
    :class="{ 'has-banner-text-color': !!bannerTextColor }"
  >
    <v-container fluid class="pa-0 fill-height">
      <v-row no-gutters class="fill-height">
        <!-- Left Column -->
        <v-col cols="4" class="d-flex flex-column justify-space-between pa-2">
          <!-- Title -->
          <div class="d-flex align-center" style="min-height: 24px;">
            <v-toolbar-title :style="bannerTextColorStyle">
              Narwhal - Qu-Bit Module Config
            </v-toolbar-title>
          </div>
          <!-- File Input -->
          <div class="d-flex align-center">
            <v-file-input
              class="flex-grow-1"
              id="user-settings"
              accept=".json"
              label="load from options.json"
              density="compact"
              :model-value="userFile"
              @update:model-value="$emit('update:userFile', $event)"
              @change="$emit('importSettings')"
              @drop.prevent="$emit('dropFile', $event)"
              @dragover.prevent
              :style="bannerTextColorStyle"
            />
          </div>
        </v-col>

        <!-- Center Column -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <a v-if="brandLogo && brandUrl" :href="brandUrl" target="_blank" rel="noopener noreferrer">
            <img
              :src="brandLogo"
              alt="Brand Logo"
              style="height: 90px; cursor: pointer;"
            />
          </a>
          <img
            v-else-if="brandLogo"
            :src="brandLogo"
            alt="Brand Logo"
            style="height: 90px;"
          />
        </v-col>

        <!-- Right Column -->
        <v-col cols="4" class="d-flex flex-column justify-center pa-2">
          <!-- Empty top space -->
          <div style="min-height: 24px;"></div>
          <!-- Action buttons aligned to match file input -->
          <div class="d-flex align-center justify-end ga-2">
            <v-btn variant="elevated" color="secondary" @click="$emit('restoreDefaults')" :style="bannerTextColorStyle" aria-label="Restore defaults">
              <v-icon>mdi-restore</v-icon>Defaults
            </v-btn>
            <v-btn variant="elevated" color="primary" @click="$emit('generate')" :style="bannerTextColorStyle" aria-label="Download configuration file">
              <v-icon>mdi-download</v-icon>Download
            </v-btn>
            <v-btn icon="mdi-theme-light-dark" color="blue" @click="$emit('toggleDark')" :style="bannerTextColorStyle" aria-label="Toggle light and dark theme"></v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    bannerImage: String,
    bannerTextColor: String,
    brandLogo: String,
    brandUrl: URL,
    userFile: Object
  },
  emits: ['dropFile', 'update:userFile', 'importSettings', 'restoreDefaults', 'generate', 'toggleDark'],
  computed: {
    computedBarStyle() {
      const img = this.bannerImage ? `background-image: url(${this.bannerImage}); background-size: cover; background-position: center;` : ''
      return img
    },
    bannerTextColorStyle() {
      return this.bannerTextColor ? { color: this.bannerTextColor } : undefined
    }
  }
}
</script>

<style scoped>
.has-banner-text-color :deep(.v-toolbar-title),
.has-banner-text-color :deep(.v-field__input),
.has-banner-text-color :deep(.v-btn),
.has-banner-text-color :deep(.v-icon) {
  /* Ensure custom color overrides theme only within banner */
  color: inherit;
}
</style>
